<template>
    <v-app>
        <!-- :mini-variant="!drawer"
            :expand-on-hover="!drawer" -->
        <v-navigation-drawer
            v-if="$store.getters['global/auth'].loggedIn && $store.getters['global/auth'].perfil != 2 && $store.getters['global/auth'].multipleregistro == false"
            v-model="drawer"
            app
        >
            <v-list-item class="justify-center py-1">
                         
                <v-img src="../assets/LogoSagrilapp.jpg"
                    max-height="100"
                    max-width="200"
                ></v-img>
                
            </v-list-item>
            <v-divider></v-divider>
            <v-list dense subheader>
                <template v-for="item in $store.getters['global/auth'].opcionesMenu">
                <v-list-group
                    v-if="item.children.length > 0"
                    :value="false"
                    :key="item.descripcion"
                    :prepend-icon="item.icon"
                    no-action
                >
                    <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.descripcion }}</v-list-item-title>
                    </v-list-item-content>
                    </template>
                    <v-list-item
                    v-for="(child, i) in item.children"
                    :key="i"
                    @click="rutaMenu(child.ruta)"
                    dense
                    class="pl-12"
                    >
                    <v-list-item-content>
                        <v-list-item-title class="d-flex text-wrap">{{ child.descripcion }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon v-if="child.icon">
                        <v-icon>{{ child.icon }}</v-icon>
                    </v-list-item-icon>
                    </v-list-item>
                </v-list-group>
                <v-list-item v-else-if="item.parent_id == null" :key="item.descripcion" @click="rutaMenu(item.ruta)">
                    <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                    <v-list-item-title class="d-flex text-wrap">{{ item.descripcion }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                </template>
            </v-list>
            

            <!-- Slot append para fijar los ítems abajo -->
            <template v-slot:append>
                <v-divider></v-divider>
                <v-list-item
                    @click="mesaDeAyuda"
                    style="cursor:pointer"
                >
                    <v-list-item-action>
                        <v-icon>mdi-lifebuoy</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Mesa de ayuda</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    @click="rutaMenu('guiausuario')"
                    style="cursor:pointer"
                >
                    <v-list-item-action>
                        <v-icon>mdi-book-open-page-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Guía de usuario</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-navigation-drawer>
            <v-app-bar
            app
            :color="$store.getters['global/auth'].perfil > 0 ? $store.getters['global/auth'].colorapp : 'primary'"
            class="flex-grow-0"
            dense
            dark
            >
           
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$store.getters['global/auth'].loggedIn">
                
                
                </v-app-bar-nav-icon>
                <v-toolbar-title v-if="$store.getters['global/auth'].loggedIn && $store.getters['global/auth'].estadoregistro >= 0">
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Estado del Registro:' : 'Estado del Registro / registration status:'}}
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 0"
                    class="ma-2"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Sin terminar' : 'Sin terminar / unfinished'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 1"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 2"
                    class="ma-2"
                    color="green"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Aprobado Sin Firmar' : 'Aprobado Sin Firmar / in Review'}}                    
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 3"
                    class="ma-2"
                    color="red"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'No Aprobado' : 'No Aprobado / Not approved'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 4"
                    class="ma-2"
                    color="brown"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Corrección de Información' : 'Corrección de Información / Information Correction'}}                    
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 5"
                    class="ma-2"
                    color="lime darken-3"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Actualizar Información' : 'Actualizar Información / Update information'}}                    
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 6"
                    class="ma-2"
                    color="deep-orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Finalizando Revisión' : 'Finalizando Revisión / Finalizing Review'}}                         
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 7"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 8"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 9"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 10"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 11"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Formulario en proceso de firma' : 'Formulario en proceso de firma / Form in signing process'}}                    
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 12"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'Aprobado y Firmado' : 'Aprobado y Firmado / Approved and Signed'}}                                        
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 15"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                    <v-chip
                    v-if="$store.getters['global/auth'].estadoregistro == 16"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    >
                    {{ $store.getters['global/auth'].tiporegistro == '1' ? 'En Revisión' : 'En Revisión / in Review'}}
                    </v-chip>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu offset-y v-if="$store.getters['global/auth'].loggedIn">
                <template v-slot:activator="{ on, attrs }">
                    <v-toolbar-title
                    v-bind="attrs"
                    v-on="on"
                    >
                    <v-list-item>                        
                        <v-list-item-content class="text-right align-self-start">
                            <v-list-item-title class="text-h6">
                                <span>{{ $store.getters['global/auth'].Name }}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-h8">
                                <span>{{ $store.getters['global/auth'].empresa }}</span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-avatar>
                            <v-icon large>
                                mdi-account-circle
                            </v-icon>
                        </v-list-item-avatar>
                    </v-list-item>                        
                        
                    </v-toolbar-title>           
                </template>
                <v-list>
                    <v-list-item @click="logout">
                        <v-list-item-title>
                            Cerrar Sesión
                        </v-list-item-title>
                        <v-list-item-icon>
                            <v-icon>mdi-exit-to-app</v-icon>
                            
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
                </v-menu>
            
            </v-app-bar>

            <v-main>
                <v-container fluid class="pa-0 fill-height">
                    <v-row align="center" justify="center" class="ma-0 fill-height">
                        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <router-view/>
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>

            <v-footer padless app
            :color="$store.getters['global/auth'].perfil > 0 ? $store.getters['global/auth'].colorapp : 'primary'"
            class="flex-grow-0 justify-center"
            dense
            dark>  
                    ® 2023 Sagrilapp by Metalsoft - Metalteco S.A.S, Todos los derechos reservados
            </v-footer>
        </v-app>
        
</template>

<script>

    export default{
        name: 'HelloWorld',
        components:{

        },
        data: () => ({
            drawer:true
        }),
        methods:{
            async logout () {
                try {
                   await this.$store.dispatch("global/logout")
                } catch (error) {
                    console.log(error)
                }
            },
            rutaMenu (ruta) {
               this.$router.push(`/${ruta}`)
            },
            mesaDeAyuda () {
                window.open('https://helpdesk.sagrilappweb.com', '_blank')
            }
        },
        create:{
            
        },
        
        mounted(){
            
        }
    }
</script>